<template>
  <div v-if="user"  class="grid grid-cols-2 gap-4">
    <Widget class="col-span-2">
      <WidgetHeader>
        <div class="flex">
          Subscription Limits
        </div>
      </WidgetHeader>
      <WidgetBody class="pt-0">
        <div class="grid grid-cols-2 gap-x-4">
            <div class="group">
                <div class="text-sm font-bold">CPA Campaign</div>
                <div class="flex items-center gap-2">
                    <div>
                        <div v-if="cpaCampaignRestriction" class="flex items-center gap-2 text-2xl font-semibold">
                            <animated-number
                                :value="cpaCampaignRestriction.data.subscribeCount"
                                :round="true"
                                :duration="300"
                                easing="easeOutExpo"
                            ></animated-number>
                            / 
                            <EditableValue
                                :key="cpaCampaignRestriction.id"
                                type="contentEditable"
                                :value="cpaCampaignRestriction.data.maxSubscriptions"
                                :mutation="UPDATE_PUBLISHER_RESTRICTION_MUTATION"
                                :variables="{
                                    input: { id: cpaCampaignRestriction.id, data: { maxSubscriptions: '{value}' } }
                                }"
                                :edit-focus-icon-enabled="false"
                            />
                        </div>
                        <div v-else>
                            <div class="text-blue-600 py-3 font-semibold">
                                Unlimited
                            </div>
                        </div>
                        <div class="text-xs text-gray-500 font-semibold">
                            <template v-if="cpaCampaignRestriction">
                                {{ cpaCampaignRestriction.frequency.toUpperCase() }}
                            </template>
                           
                        </div>
                    </div>
                    <div class="flex items-center justify-end group-hover:opacity-100 opacity-0 transition-opacity duration-300">
                        <button v-if="!cpaCampaignRestriction" @click="createCampaignRestriction('cpa')" :disabled="isLoading">
                            <Icon
                              name="plus"
                              :size="6"
                              class="text-blue-300 hover:text-blue-600"
                            />
                        </button>
                        <button v-if="cpaCampaignRestriction" @click="removeCampaignRestriction(cpaCampaignRestriction.id)" :disabled="isLoading">
                            <Icon
                              name="close"
                              :size="6"
                              class="text-red-300 hover:text-red-600"
                            />
                        </button>

                    </div>
                </div>
            </div>
            <div class="group">
                <div class="text-sm font-bold">CPL Campaign</div>
                <div class="flex items-center gap-2">
                    <div>
                        <div v-if="cplCampaignRestriction" class="flex items-center gap-2 text-2xl font-semibold">
                            <animated-number
                                :value="cplCampaignRestriction.data.subscribeCount"
                                :round="true"
                                :duration="300"
                                easing="easeOutExpo"
                            ></animated-number>
                            / 
                            <EditableValue
                                :key="cplCampaignRestriction.id"
                                type="contentEditable"
                                :value="cplCampaignRestriction.data.maxSubscriptions"
                                :mutation="UPDATE_PUBLISHER_RESTRICTION_MUTATION"
                                :variables="{
                                    input: { id: cplCampaignRestriction.id, data: { maxSubscriptions: '{value}' } }
                                }"
                                :edit-focus-icon-enabled="false"
                            />
                        </div>
                        <div v-else>
                            <div class="text-blue-600 py-3 font-semibold">
                                Unlimited
                            </div>
                        </div>
                        <div class="text-xs text-gray-500 font-semibold">
                            <template v-if="cplCampaignRestriction">
                                {{ cplCampaignRestriction.frequency.toUpperCase() }}
                            </template>
                           
                        </div>
                    </div>
                    <div class="flex items-center justify-end group-hover:opacity-100 opacity-0 transition-opacity duration-300">
                        <button v-if="!cplCampaignRestriction" @click="createCampaignRestriction('cpl')" :disabled="isLoading">
                            <Icon
                              name="plus"
                              :size="6"
                              class="text-blue-300 hover:text-blue-600"
                            />
                        </button>
                        <button v-if="cplCampaignRestriction" @click="removeCampaignRestriction(cplCampaignRestriction.id)" :disabled="isLoading">
                            <Icon
                              name="close"
                              :size="6"
                              class="text-red-300 hover:text-red-600"
                            />
                        </button>

                    </div>
                </div>
            </div>
        </div>



       
        <!-- <div class="text-2xl md:text-4xl">
          <animated-number
            :value="totalVisitors"
            :formatValue="toLocaleString"
            :duration="1000"
            easing="easeOutExpo"
          ></animated-number></div> -->
      </WidgetBody>
    </Widget>
    <!-- <Widget>
      <WidgetHeader>
        <div class="flex">
          Revenue Cap
        </div>
      </WidgetHeader>
      <WidgetBody>
        <div></div>
      </WidgetBody>
    </Widget> -->
  </div>
</template>
<script>
import AnimatedNumber from 'animated-number-vue'
import EditableValue from '@/components/utilities/EditableValue.vue'
import UPDATE_PUBLISHER_RESTRICTION_MUTATION from '@/graphql/PublisherRestriction/UpdatePublisherRestrictionMutation.gql'
import DELETE_PUBLISHER_RESTRICTION_MUTATION from '@/graphql/PublisherRestriction/DeletePublisherRestrictionMutation.gql'
import CREATE_PUBLISHER_RESTRICTION_MUTATION from '@/graphql/PublisherRestriction/CreatePublisherRestrictionMutation.gql'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: { 
    AnimatedNumber,
    EditableValue,
  },
  data() {
    return {
      isLoading: false,
      UPDATE_PUBLISHER_RESTRICTION_MUTATION,
    }
  },
  methods: {
    removeCampaignRestriction(restrictionId) {
      this.isLoading = true
      this.$apollo.mutate({
        mutation: DELETE_PUBLISHER_RESTRICTION_MUTATION,
        variables: {
          id: restrictionId
        }
      })
      .then(() => {
        this.isLoading = false
        this.$events.emit('refetchUser')
      })
    },
    createCampaignRestriction(campaignType) {
      this.isLoading = true
      const maxSubscriptions = campaignType === 'cpl' ? 2 : 3
      this.$apollo.mutate({
        mutation: CREATE_PUBLISHER_RESTRICTION_MUTATION,
        variables: {
            input: {
                publisherId: this.user.id,
                type: "campaign-subscription",
                frequency: "monthly",
                data: {
                    maxSubscriptions: maxSubscriptions,
                    subscribeCount: 0,
                    campaignType: campaignType
                }
            }
        }
      }).then(() => {
        this.isLoading = false
        this.$events.emit('refetchUser')
      })
    }
  },
  computed: {
    cpaCampaignRestriction() {
      return this.user.publisherRestrictions.find(restriction => restriction.data.campaignType === 'cpa')
    },
    cplCampaignRestriction() {
      return this.user.publisherRestrictions.find(restriction => restriction.data.campaignType === 'cpl')
    },
    revenueCap() {
      return this.user.caps.find(cap => cap.type === 'payout')
    }
  }
}
</script>